/** @format */

import React, { useState } from "react";
import { BiShow, BiHide } from "react-icons/bi";

const InputPassword = ({
  required,
  value,
  error,
  setValue,
  note,
  title,
  placeholder,
  id,
  name,
  onChange,
}) => {
  const [togglePass, setTogglePass] = useState(true);

  const handleInput = (e) => {
    // setValue(e.target.value);
  };

  return (
    <div className='input__box'>
      <label className='input__label' htmlFor='email'>
        {title}{" "}
        {note && (
          <span style={{ fontSize: "2rem", color: "red", marginLeft: "1rem" }}>
            {note}{" "}
          </span>
        )}
        {error && (
          <span
            style={{ fontSize: "1.2rem", color: "red", marginLeft: "1rem" }}>
            {error}{" "}
          </span>
        )}
      </label>
      <div className='input__password'>
        <input
          required={required}
          id={id}
          type={togglePass ? "password" : "text"}
          className='input__field'
          name={name}
          value={value}
          onChange={onChange}
          autocomplete='false'
          placeholder={placeholder ? placeholder : ""}
          style={{ background: "#FAFAFA", border: "2px solid #E0E0E0" }}
        />
        <div style={{ fontSize: "2.5rem" }} className='toggle-pass'>
          {!togglePass && <BiShow onClick={() => setTogglePass(!togglePass)} />}
          {togglePass && <BiHide onClick={() => setTogglePass(!togglePass)} />}
        </div>
      </div>
    </div>
  );
};
export default InputPassword;
